import React, {useCallback, useEffect, useRef, useState} from 'react'
import PropTypes from 'prop-types'
import {renderLabel} from '../textfield'

const detectCardTypec = (number) => {
  var re = {
    visa: /^4[0-9]{12}(?:[0-9]{3})?$/,
    mastercard: /^5[1-5][0-9]{14}$/,
    amex: /^3[47][0-9]{13}$/
  }
  if(number){
    number = number.split(' ').join('')
    for(var key in re) {
      if(re[key].test(number)) {
        return key
      }
    }
  }
  return undefined
}

let CCnumberFields = (props) =>{
  const { input , callback, meta,label} = props
  const textfieldRef = useRef(null)
  const initFlag = useRef(null)
  const [cardType,setCardType] = useState(undefined)

  const onTextfieldKeyUp = useCallback(() => {
    const number = textfieldRef.current.value
    if(callback) {
      const type = detectCardTypec(number) ? detectCardTypec(number) : null
      setCardType(type)
      callback(type, meta, initFlag)
    }
  },[textfieldRef,callback,setCardType,meta,initFlag])

  useEffect(()=>{
    if(!initFlag.current){
      onTextfieldKeyUp()
      initFlag.current = true
    }
  },[initFlag,onTextfieldKeyUp])



  return (
    <div className={'of-cc-number-field'}>
      {renderLabel(label,input.value)}
      <div className={'of-cc-number-field__wrapper lines-border-1-100'}>
        <input {...input} ref={textfieldRef} placeholder={'Credit Card Number'} onKeyUp={onTextfieldKeyUp} className={'of-cc-number-field__textfield'}/>
        {cardType?<div className={'of-cc-number-field__type'}>
          <i className={`icon-of-${cardType}-outline`} />
        </div>:<></>}
      </div>
    </div>
  )
}

CCnumberFields.propTypes = {
  input : PropTypes.any,
  callback: PropTypes.func,
  meta: PropTypes.any,
  label: PropTypes.string
}

export default CCnumberFields